import { Grid } from '@mui/material';
import React from 'react';
import { ITableCard } from './ITableCard';

export default function TableCard({
    date,
    element,
    price,
    sayadNumber,
}: ITableCard) {
    return (
        <Grid
            container
            xs={12}
            className={`${element !== 'body' ? 'p-1' : 'p-2 !mb-1 '} `}
            sx={{
                border: '1.5px solid #DAE0E4',
                borderRadius: '8px',
                boxShadow: '2px 2px 3px rgba(0, 0, 0, 0.1)',
                background: `${element === 'body' ? ' #fff' : 'var(--tirnary-text-color)irnary-text-color)'}`,
                color: `${element !== 'body' ? ' #fff' : 'var(--primary-text-color)'}`,
                fontSize: '.7rem',
            }}
        >
            <Grid sx={{ paddingRight: '.3em' }} xs={6} textAlign={'center'}>
                {sayadNumber}
            </Grid>
            {/* <Grid xs={1} textAlign={'center'} sx={{ color: `${element === 'body' ? '#E6E9F4' : '#ffffff50'}` }}>
                |
            </Grid>
            <Grid xs={3} textAlign={'left'}>
                {price?.toLocaleString()}
            </Grid> */}
            <Grid xs={1} textAlign={'left'} sx={{ color: `${element === 'body' ? '#E6E9F4' : '#ffffff50'}` }}>
                |
            </Grid>
            <Grid xs={5} textAlign={'center'}>
                {date}
            </Grid>
        </Grid>
    );
}
